import { useQuery } from "react-query";
import { getUserPermissions } from "~/hooks/request/getUserPermissions";

export default function useGetUserPermissions() {
  return useQuery({
    queryKey: ["getUserPermissions"],
    queryFn: () => getUserPermissions(),
    refetchOnWindowFocus: false,
    enabled: false,
    cacheTime: 0,
  });
}
